"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN ScriptTask.
 *
 * This type of task is used to execute JS code snippets.
 */
class ScriptTask extends ActivityBase_1.Activity {
    get bpmnType() {
        return Constants_1.BpmnType.scriptTask;
    }
}
exports.ScriptTask = ScriptTask;
//# sourceMappingURL=ScriptTask.js.map